/**
 * Clés i18n des messages flash (toasts) partagés.
 * Libellés FR dans assets/i18n/fr.json.
 */
export const FLASH_MESSAGES = {
  bienLoueEnEntier: 'flash.bienLoueEnEntier',
  bienSupprime: 'flash.bienSupprime',
  bienMisAJour: 'flash.bienMisAJour',
  uniteMiseAJour: 'flash.uniteMiseAJour',
  uniteSupprimee: 'flash.uniteSupprimee',
  uniteEtBienSupprimes: 'flash.uniteEtBienSupprimes',
  gestionUniteReouverte: 'flash.gestionUniteReouverte',
  contactSupprime: 'flash.contactSupprime',
  contactRefuse: 'flash.contactRefuse',
  contactRouvert: 'flash.contactRouvert',
  documentTechniqueUploade: 'flash.documentTechniqueUploade',
  documentTechniqueSupprime: 'flash.documentTechniqueSupprime',
  documentTechniqueExpirationMaj: 'flash.documentTechniqueExpirationMaj',
  documentAchatUploade: 'flash.documentAchatUploade',
  documentAchatSupprime: 'flash.documentAchatSupprime',
  locataireDensiteAlerte: 'flash.locataireDensiteAlerte',
  locataireSupprime: 'flash.locataireSupprime',
  locataireSupprimeDefinitivement: 'flash.locataireSupprimeDefinitivement',
  locataireReactive: 'flash.locataireReactive',
} as const;

/**
 * Clés i18n des messages d'erreur UI répétés en TypeScript.
 */
export const UI_MESSAGES = {
  impossibleEnregistrerModifications: 'ui.impossibleEnregistrerModifications',
  impossibleAjouterUnite: 'ui.impossibleAjouterUnite',
} as const;
